// front/src/components/common/Button/Button.styles.js
import styled from 'styled-components';

const getVariantStyles = (variant) => {
  const variants = {
    primary: {
      backgroundColor: '#6AB8A8',
      color: 'white',
      '&:hover': {
        backgroundColor: '#5aa396',
      }
    },
    secondary: {
      backgroundColor: '#FF9F1F',
      color: 'white',
      '&:hover': {
        backgroundColor: '#e8900d',
      }
    },
    outline: {
      backgroundColor: 'transparent',
      color: '#6AB8A8',
      border: '2px solid #6AB8A8',
      '&:hover': {
        backgroundColor: '#6AB8A8',
        color: 'white',
      }
    },
    danger: {
      backgroundColor: '#dc3545',
      color: 'white',
      '&:hover': {
        backgroundColor: '#c82333',
      }
    },
    ghost: {
      backgroundColor: 'transparent',
      color: '#4a4a4a',
      border: '1px solid #d0d0d0',
      '&:hover': {
        backgroundColor: '#f0f0f0',
      }
    }
  };
  return variants[variant] || variants.primary;
};

const getSizeStyles = (size) => {
  const sizes = {
    small: {
      padding: '8px 16px',
      fontSize: '14px',
      height: '32px'
    },
    medium: {
      padding: '12px 24px',
      fontSize: '16px',
      height: '40px'
    },
    large: {
      padding: '16px 32px',
      fontSize: '18px',
      height: '48px'
    }
  };
  return sizes[size] || sizes.medium;
};

export const ButtonContainer = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease;
  text-decoration: none;
  position: relative;
  overflow: hidden;
  
  ${({ variant }) => getVariantStyles(variant)}
  ${({ size }) => getSizeStyles(size)}
  
  ${({ fullWidth }) => fullWidth && 'width: 100%;'}
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(106, 184, 168, 0.3);
  }
  
  &:active {
    transform: translateY(1px);
  }
`;

export const ButtonText = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ButtonIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
`;